import type { EmbeddedCompany } from 'types';
import type { Sums } from '../common/types';
import type { EmbeddedUser } from 'modules/core/types';
import type { Brand } from 'modules/client/types';
import type { ClientAgreement } from 'modules/client/agreement/types';
import type { Attachment } from 'modules/attachments/types';
import type { Topic } from 'modules/comments/types';
import type { TaskList } from 'modules/tasks/types';
import { EditorValue } from 'components/RichText';

export const campaignStates = ['NEW', 'IN_PROCESS', 'DONE', 'CANCELED'] as const;
export type CampaignState = (typeof campaignStates)[number];

export const campaingGoals = ['AWARENESS', 'CONSIDERATION', 'CONVERSION', 'RETENTION'] as const;
export type CampaignGoal = (typeof campaingGoals)[number];

export interface CampaignSums extends Sums {
  state: CampaignState;
}

export interface ListCampaign {
  id: number;
  number: string;
  title: string;
  client: EmbeddedCompany;
  payer: EmbeddedCompany;
  manager: EmbeddedUser;
  date_from: string;
  date_to: string;
  sums: CampaignSums;
}

export interface CampaignDetails extends ListCampaign {
  agreement: ClientAgreement;
  client_po_number: string | null;
  role: {
    manage: boolean;
  };
  brand: Brand | null;
  manager: EmbeddedUser;
  involved: EmbeddedUser[];
  comment: string;
  attachments?: Attachment[];
  topic: Topic;
  task_list: TaskList;

  goals: CampaignGoal[];
  brief: EditorValue;
  total_budget: string | null;
}
